module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table-run', {
    staticClass: "no-selectable-table detail-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-switch": false,
      "include-settings": false,
      "include-delete-single": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_c('router-link', {
          staticClass: "to-kardex",
          attrs: {
            "to": {
              name: 'kardex',
              params: {
                productId: props.row.id,
                productName: props.row.name
              }
            }
          }
        }, [_vm._v("\n\t\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6796c9c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ListOfDetails.vue
// module id = 1656
// module chunks = 52